import ltdInfo1 from '/images/charts/ltd-info-1.png';

const info = [
    {
        tag: 'h1',
        content: 'Lead Time Distribution (LTD)',
    },
    {
        tag: 'p',
        content: `The LTD chart shows the distribution of days for the selected
        period that your tasks take from the moment of creation to completion.`,
    },
    {
        tag: 'p',
        content: 'By understanding the number of tasks solved for a certain number of days, you can:',
    },
    {
        tag: 'ul',
        childs: [
            {
                tag: 'li',
                content: 'Analyze the efficiency of task execution and identify areas for optimizing your processes;',
            },

            {
                tag: 'li',
                content: 'Predict the amount of time required to complete a new task.',
            },
        ],
    },
    {
        tag: 'br',
    },
    {
        tag: 'h2',
        content: 'How the LTD chart is set up',
    },
    {
        tag: 'img',
        attributes: {
            src: ltdInfo1,
        },
    },
    {
        tag: 'ul',
        childs: [
            {
                tag: 'li',
                content: 'On the X-axis are the days,',
            },

            {
                tag: 'li',
                content: 'On the Y-axis are the number of tasks solved.',
            },
        ],
    },
    {
        tag: 'p',
        content: 'On the given chart, it can be seen that 8 tasks were completed in 4 days, and 2 tasks in 10 days.',
        attributes: {
            style: {
                backgroundColor: 'yellow',
                display: 'inline',
            },
        },
    },
    {
        tag: 'br',
    },
    {
        tag: 'h2',
        content: 'Interpretation of the chart',
    },
    {
        tag: 'p',
        content: 'The chart has the following main zones:',
    },
    {
        tag: 'ul',
        childs: [
            {
                tag: 'li',
                content: 'Concentration of the majority of solved tasks;',
            },

            {
                tag: 'li',
                content: 'Right tails.',
            },
        ],
    },
    {
        tag: 'p',
        content: `Depending on the specifics of your company, the main part of solved
        tasks may be in the left part of the chart, or close to the middle.
        It contains "typical" tasks that your team faces.`,
    },
    {
        tag: 'p',
        content: `The narrower the zone with the main part of tasks,
        the more stable the development processes are.`,
    },
    {
        tag: 'p',
        content: `The higher the columns on the chart in the right tails and the longer
        the X-axis, the more inconsistent the task execution time, which may indicate
        an increased complexity of these tasks or a connection with various factors
        such as task blocking or changes in requirements/redesign of tasks.`,
    },
    {
        tag: 'p',
        content: `In an ideal situation, the histogram should
        mainly show higher columns on the left side.`,
    },
    {
        tag: 'p',
        content: `If your LTD chart shows a strong tail, it is recommended to analyze
        tasks with a longer completion time and develop a plan to address the issues causing the delays.`,
    },
    {
        tag: 'br',
    },
    {
        tag: 'h2',
        content: 'Task completion time forecasting',
    },
    {
        tag: 'p',
        content: `Since the chart demonstrates already solved tasks by your team, then based on previous
        data, you can forecast the probability of completion time for a new task.`,
    },
    {
        tag: 'p',
        content: 'Percentiles of completed tasks are used for forecasting.',
    },
    {
        tag: 'p',
        content: 'For example, consider an LTD chart for tasks solved during the last quarter:',
    },
    {
        tag: 'ul',
        childs: [
            {
                tag: 'li',
                content: '50% of tasks were solved in 2 days or less;',
            },
            {
                tag: 'li',
                content: '85% of tasks were solved in 7 days or less;',
            },
            {
                tag: 'li',
                content: '95% of tasks were solved in 18 days or less.',
            },
        ],
    },
    {
        tag: 'p',
        content: `Therefore, when a new task arrives, it can be said that with a 95% probability
        the team will solve it within 18 days, and with an 85% probability
        the task will be solved in 7 days or less`,
    },
];

export default {
    info: JSON.stringify(info),
    for: 'for',
    quantity: 'Quantity',
    days: 'Days',
    issues: 'Issues',
};
